<div>
  <div class="v4-layout-form v4-layout-form-vertical" [formGroup]="form">
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "word.name" | translate }}
        <!-- Name -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <input formControlName="title" type="text" nz-input nzSize="large" [placeholder]="'word.name' | translate" />
        </div>
      </div>
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "word.image" | translate }}
        <!-- Cover -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <host-base-image-upload [maxSize]="1" formControlName="cover"></host-base-image-upload>
        </div>
      </div>
    </div>
  </div>

  <div class="footer flex flex-row items-center justify-between">
    <div class="ml-auto">
      <button class="mr-3" nz-button nzSize="large" (click)="onCancel()">
        {{ "word.cancel" | translate }}
        <!-- Cancel -->
      </button>
      <button nz-button nzSize="large" nzType="primary" (click)="onSave()">
        {{ "word.save" | translate }}
        <!-- Save -->
      </button>
    </div>
  </div>
</div>
